import { Outlet } from 'react-router-dom'

export function Movements() {
  return <Outlet />
}
